import { render } from "./LogoutCard.vue?vue&type=template&id=4309aaea"
const script = {}
script.render = render

export default script